import {
  Caption2,
  Color,
  Image as CitrusImage,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

export const ContainedImage = withCitrusTheme(CitrusImage, () => ({
  display: 'block',
  objectFit: 'cover',
  objectPosition: 'center',
  borderRadius: '0',
}))

export const RTHBadge = withCitrusTheme(Caption2, (theme) => ({
  color: theme.color(Color.White),
  backgroundColor: theme.color(Color.Warning_900),
  borderRadius: '3px',
  width: 'fit-content',
  padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
  marginBottom: `${theme.spacing(1)}px`,
}))

export const PremiumBadge = withCitrusTheme(Caption2, (theme) => ({
  color: theme.color(Color.ColdGrey_800),
  backgroundColor: theme.color(Color.NeutralGrey_100),
  borderRadius: '3px',
  width: 'fit-content',
  padding: `${theme.spacing(0.5)}px ${theme.spacing(2)}px`,
}))
